import React, { FC, ReactElement } from 'react';

import './Stub.scss';

type StubProps = {
  type: 'mobile' | 'denied';
};

const Stub: FC<StubProps> = ({ type }): ReactElement => (
  <div className="mobilestub-container">
    <div className="mobilestub-content">
      <h1>{type === 'mobile' ? <>This app is best viewed on a desktop</> : <>Access denied</>}</h1>
      <p>
        {type === 'mobile' ? (
          <>For an optimal experience, please access this site on a larger screen.</>
        ) : (
          <>For some reason, access is limited, reload the page or contact the admin.</>
        )}
      </p>
    </div>
  </div>
);

export default Stub;
